import * as angular from 'angular';
import './fileBrowserApprovalActionBar.html'

angular.module('GorillaBoy.Approvals')
.directive('approvalActionBar', [
    function folderInfoButton() {
    return {
        restrict: 'E',
        templateUrl: './approvals/approvalActionBar/fileBrowserApprovalActionBar.html'
    };
}])